import React, { use } from 'react'
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Loader from './Loader'
import Navbar from "./Navbar";
import Header from './Header'
import Footer from './Footer'
import ListContainer from './container/ListContainer';
import useSidebarToggle from '../hooks/useSidebarToggle';
function StudentList({ studentId, setStudentId , improvementCandidateIds, setImprovementCandidateIds , supplementaryCandidateIds ,setSupplementaryCandidateIds }) {
    const location = useLocation();
    useSidebarToggle();
 
    return (
        <div>
            <Loader />
            <Navbar />
            <Header />
            <ListContainer studentId={studentId} setStudentId={setStudentId} improvementCandidateIds={improvementCandidateIds} setImprovementCandidateIds={setImprovementCandidateIds}
            supplementaryCandidateIds={supplementaryCandidateIds} setSupplementaryCandidateIds={setSupplementaryCandidateIds} />
            <Footer />
        </div>
    )
}

export default StudentList